
import { TextField, InputAdornment, IconButton } from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface SearchTextFieldProps {
    value:      string;
    onChange:   (value: string) => void;
    label?:     string;
    onClear?:   () => void;
}

export const SearchTextField = ({ value, onChange, label = 'Buscar', onClear }: SearchTextFieldProps) => {

    const handleClear = () => {
        onChange('');
        onClear?.();
    };

    return (
        <TextField
            fullWidth
            variant="outlined"
            label={label}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            sx={{
                backgroundColor: 'white',
                borderRadius: 2,
                color: '#e0e0e0',
                '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                },
                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#e0e0e0',
                },
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#e0e0e0',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    color: 'gray',
                },
            }}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">

                            <SearchIcon color="action" />

                        </InputAdornment>
                    ),
                    endAdornment: value && (
                        <InputAdornment position="end">

                            <IconButton size="small" onClick={handleClear}>
                                <ClearIcon fontSize="small" />
                            </IconButton>

                        </InputAdornment>
                    ),
                }
            }}
        />
    );
};
